//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import anime from 'animejs';
import Slick from 'vue-slick';
import longArrowRight from 'images/long_arrow_right.png';
import longArrowLeft from 'images/long_arrow_left.png';

export default {
  props: {
    people: Array,
  },
  data: function() {
    return {
      selectedPerson: this.people && this.people[0],
      slickOptions: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        prevArrow: `<button class="button button--prev">
          <img src="${longArrowLeft}" /> prev
        </button>`,
        nextArrow: `<button class="button button--next">
          next <img src="${longArrowRight}" />
        </button>`,
      },
    };
  },
  methods: {
    handleAfterChange: function(event, slick, currentSlide) {
      anime({
        targets: this.$refs.selectedPeopleContainer,
        opacity: 0,
        duration: 300,
        translateY: '-200px',
        easing: 'easeInOutSine',
      });

      setTimeout(() => {
        console.log(currentSlide, slick.currentSlide);
        this.selectedPerson = this.people[currentSlide];

        anime({
          targets: this.$refs.selectedPeopleContainer,
          opacity: 1,
          translateY: 0,
          duration: 600,
          easing: 'easeInOutSine',
        });
      }, 300);
    },
  },
  components: {
    Slick,
  },
};



// WEBPACK FOOTER //
// ./scripts/vue/our-people/OurPeopleCarousel.vue